module.exports = __webpack_public_path__ + "media/images/wealthbar/2fa/authenticator-inactive-989fd1ef0d7c88192ef3dd3da74e957b.svg";